export const error_something_wrong_text = 'Something went wrong!';
export const error_something_wrong_sub_text =
  'Sorry, this is embarrassing. Please try again.';
export const error_something_wrong_button = 'Retry';
